import { Button, Modal, Text } from '@driftt/dds'
import React from 'react'

import { CONFIRMATION_TEXT_COPIES, PROMPT_MODES } from '../../constants'

interface ConfirmationModal {
  aiMode?: keyof typeof PROMPT_MODES
  isOpen: boolean
  handleClose: () => void
  handleContinue: () => void
  isLoading: boolean
}

const ConfirmationModal = ({
  isOpen = false,
  isLoading,
  handleContinue,
  handleClose,
}: ConfirmationModal) => {
  const { title, description } = CONFIRMATION_TEXT_COPIES

  return (
    <Modal.Root open={isOpen} onClose={handleClose}>
      <Modal.Dialog size="large" variant="warning">
        <Modal.Title title={title} />

        <Modal.Content scrollOverflow="inside">
          <Text>{description}</Text>
        </Modal.Content>

        <Modal.Actions>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleContinue}
            loading={isLoading}
          >
            Yes, update rules
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default ConfirmationModal
